import { Route, Routes } from 'react-router-dom';
import { ProtectedRouter } from 'infrastructure/routing';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import QualificationStructurePageLayout from './QualificationStructurePageLayout';
import { QUALIFICATION_STRUCTURE_PATH, useQualificationStructureRoute } from './routing';
import {
  CREATE_QUALIFICATION_STRUCTURES,
  QUALIFICATION_STRUCTURE_LIST_READ,
} from './services/qualificationStructureService';
import PeopleManagersContext from './PeopleManagersContext';
import QualificationStructureBuilder from './create/QualificationStructureBuilder';
import QualificationStructureList from './List/QualificationStructureList';
import TargetRulePage from './TargetRulePage';

const QualificationStructureRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute, builderRoute, structureListRoute, targetRuleRoute } = useQualificationStructureRoute();

  return (
    <ProtectedRouter basePath={QUALIFICATION_STRUCTURE_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <PeopleManagersContext permissionToCheck={QUALIFICATION_STRUCTURE_LIST_READ}>
              <QualificationStructurePageLayout />
            </PeopleManagersContext>
          }
        />
        <Route
          path={builderRoute}
          element={
            <PeopleManagersContext permissionToCheck={CREATE_QUALIFICATION_STRUCTURES}>
              <QualificationStructureBuilder />
            </PeopleManagersContext>
          }
        />
        <Route
          path={structureListRoute}
          element={
            <PeopleManagersContext permissionToCheck={QUALIFICATION_STRUCTURE_LIST_READ}>
              <QualificationStructureList />
            </PeopleManagersContext>
          }
        />
        <Route
          path={targetRuleRoute}
          element={
            <PeopleManagersContext permissionToCheck={QUALIFICATION_STRUCTURE_LIST_READ}>
              <TargetRulePage />
            </PeopleManagersContext>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

QualificationStructureRouter.getRouterPath = () => `${QUALIFICATION_STRUCTURE_PATH}/*`;

export default QualificationStructureRouter;
